import { createSelector } from 'reselect';

const floatingSidebarSelector = state => state.floatingSidebar;

export const showTecarTileSelector = createSelector([floatingSidebarSelector], floatingSidebar => floatingSidebar.showTecarTile);
